import React from 'react';

import DecentText from '~/components/patterns/typography/DecentText';

import {
	useUserAgentsQuery,
} from './UserAgentHeaderValue.gql';

import {
	UserAgent,
} from '~/model/websites/userAgents';



function usePrefetch() {
	return useUserAgentsQuery();
}



type Props = {
	userAgent?: UserAgent | null,
	customHeaderValue?: string | null,
	isUserAgentBranded: boolean,
	userAgentOptions?: ReadonlyArray<{
		readonly headerValue: string,
		readonly isBranded: boolean,
		readonly type: string,
	}> | null,
};

const UserAgentHeaderValue: React.FC<Props> = (props) => {
	const {
		customHeaderValue = null,
		userAgent: userAgentType = null,
		isUserAgentBranded,
		userAgentOptions,
	} = props;

	const { data } = useUserAgentsQuery();

	if (userAgentType === UserAgent.Custom) {
		return (
			<DecentText>
				{customHeaderValue}
			</DecentText>
		);
	}

	const userAgent = userAgentOptions?.find((agent) => agent.type === userAgentType)
		|| data?.userAgents.find((agent) => agent.type === userAgentType);

	if (!userAgent) {
		return null;
	}

	const baseHeaderValue = userAgent.headerValue;

	let headerValue = baseHeaderValue;

	if (userAgentType !== UserAgent.ContentKing) {
		if (!isUserAgentBranded) {
			headerValue = baseHeaderValue
				.replace(/;\s*\+https:\/\/whatis\.contentkingapp\.com\)/, ')')
				.replace(/\s*\(\+https:\/\/whatis\.contentkingapp\.com\)/, '');
		} else {
			if (!baseHeaderValue.includes('whatis.contentkingapp.com')) {
				if (baseHeaderValue.endsWith(')')) {
					headerValue = baseHeaderValue.slice(0, -1) + '; +https://whatis.contentkingapp.com)';
				} else {
					headerValue = baseHeaderValue + ' (+https://whatis.contentkingapp.com)';
				}
			}
		}
	}

	return (
		<DecentText>
			{headerValue}
		</DecentText>
	);
};



export default UserAgentHeaderValue;

export {
	usePrefetch,
};
